const prepaidInventoryPlasticNonameTabStyle = {
	
};

export default prepaidInventoryPlasticNonameTabStyle;
